import vmClient from 'app/services/vmClient';
import { DateMarshaller } from 'app/constants/schemas/Date';
import { IEntity, Entity, IEntityType, EntityStringId } from 'app/types/entity';
import { ITeacherProfile, TeacherProfile } from 'app/constants/schemas/TeacherProfile';

export interface IWordUsageAnswer extends IEntity {
  attributes: {
    id: EntityStringId;
    answer: string;
    likeCount: number;
    createdAt: Date;
  };
  associations: {
    answerer: ITeacherProfile;
  };
}

export type WordUsageAnswer = Entity<IWordUsageAnswer>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WordUsageAnswer: IEntityType<IWordUsageAnswer> = vmClient.defineClass({
  typeName: 'Word.UsageAnswer',
  version: 1,
  persisted: true,
  attributes: {
    answer: {
      type: 'string',
      notNull: true,
    },
    likeCount: {
      type: 'number',
      notNull: true,
    },
    createdAt: {
      type: Date,
      marshaller: DateMarshaller,
      notNull: true,
    },
  },
  associations: {
    answerer: {
      type: TeacherProfile,
      notNull: true,
      shared: true,
    },
  },
});
